<a
  [routerLink]="'/home'"
  class="flex items-center rtl:space-x-reverse"
>
  <img
    src="assets/imgs/madrineros_logo.png"
    alt="Madrineros.com"
    class="h-10 w-auto max-w-[180px] object-contain"
  />
</a>
